// Panggilan antrian dengan suara otomatis (Web Speech API bawaan browser, tanpa biaya dan tanpa server suara).
// Memakai suara Bahasa Indonesia bila ada di perangkat; bila tidak ada, suara bawaan membaca teks Indonesia.
// Chrome/Edge di Windows & Android biasanya sudah punya suara Indonesia; bila tidak, pasang paket suara "Bahasa Indonesia"
// di pengaturan sistem (Windows: Pengaturan > Waktu & bahasa > Suara).
const NAMA_UMUM = ['', '-', 'customer', 'umum', 'guest', 'pelanggan', 'walk-in', 'walk-in customer'];

export const suaraTersedia = () => typeof window !== 'undefined' && 'speechSynthesis' in window && 'SpeechSynthesisUtterance' in window;

const daftarSuara = () => (suaraTersedia() ? window.speechSynthesis.getVoices() : []);
const pilihSuara = () => {
  const suara = daftarSuara();
  return suara.find((v) => /^id([-_]|$)/i.test(v.lang)) || suara.find((v) => /indonesia/i.test(v.name)) || null;
};

/** true bila perangkat punya suara Bahasa Indonesia (daftar suara kadang baru terisi setelah beberapa saat). */
export const adaSuaraIndonesia = () => !!pilihSuara();

/**
 * Teks yang diucapkan. nomor = angka antrian (dibaca sebagai bilangan, mis. 12 = "dua belas"); awalan huruf (mis. 'L' dari
 * nomor lokal HP offline) dibaca per huruf di depan nomor.
 */
export const teksPanggilan = ({ nomor, awalan = '', nama = '' }) => {
  const huruf = String(awalan || '').trim().split('').join(' ');
  const sebutNomor = `${huruf ? `${huruf} ` : ''}${parseInt(nomor, 10)}`;
  const n = String(nama || '').trim();
  const sebutNama = NAMA_UMUM.includes(n.toLowerCase()) ? '' : ` Atas nama ${n}.`;
  return `Nomor antrian ${sebutNomor}.${sebutNama} Pesanan Anda sudah siap. Silakan ke kasir.`;
};

/** Dari label tampil (mis. "012" atau "L007") ke bahan ucapan. */
export const suaraDariLabel = (label, nama = '') => {
  const m = String(label || '').match(/^([A-Za-z]*)(\d+)$/);
  return { nomor: m ? m[2] : 0, awalan: m ? m[1] : '', nama };
};

/**
 * Ucapkan panggilan (diulang [ulang] kali, jeda singkat). Mengembalikan false bila perangkat tidak mendukung suara.
 * onGalat(kode) dipanggil bila browser menolak bicara (mis. 'not-allowed': halaman belum pernah disentuh pengguna).
 */
export const panggilSuara = (item, { ulang = 2, laju = 0.9, onGalat } = {}) => {
  if (!suaraTersedia()) return false;
  const sintesis = window.speechSynthesis;
  sintesis.cancel(); // hentikan panggilan sebelumnya supaya tidak menumpuk
  const teks = teksPanggilan(item);
  const suara = pilihSuara();
  for (let i = 0; i < ulang; i += 1) {
    const u = new window.SpeechSynthesisUtterance(teks);
    u.lang = suara ? suara.lang : 'id-ID';
    if (suara) u.voice = suara;
    u.rate = laju;
    u.pitch = 1;
    u.volume = 1;
    if (onGalat) u.onerror = (e) => { if (e && e.error !== 'canceled' && e.error !== 'interrupted') onGalat(e.error); };
    sintesis.speak(u);
  }
  return true;
};
